<!-- MAIN CONTAINER -->
<div class="flex flex-wrap">

  <!-- LEFT PANEL -->
  <div class="w-full lg:w-3/5 p-2">

    <div class="flex">

      <!-- SIDEBAR THUMBNAILS -->
      <div class="w-20 flex flex-col items-center gap-3">

        <div *ngFor="let item of layoutSpaceFrames" (click)="onProductSubType(item?.type)"
          class="cursor-pointer border rounded-lg p-1" [ngClass]="{'border-black': productSubType === item?.type}">
          <img [src]="item?.image_path" class="w-14 h-14 object-cover" />
        </div>

      </div>

      <!-- MAIN IMAGE -->
      <div class="flex-1 flex items-center justify-center">

        <ng-container *ngFor="let item of layoutSpaceFrames">
          <img *ngIf="productSubType === item?.type" [src]="item?.image_path" class="max-h-[400px]" />
        </ng-container>

      </div>

    </div>

    <div class="p-4 mt-4 border-t">

      <h3 style="font-size: 17px;
    font-family: 'Roboto', sans-serif;
    color: black;">
        About This Product
      </h3>

      <p class="mt-3" style="font-size: 14px;
    font-family: 'Roboto', sans-serif;
    color: black;">
        {{ onSale?.description }}
      </p>

    </div>

  </div>


  <div class="w-full lg:w-2/5 p-4">

    <!-- TITLE -->
    <h1 class="text-2xl font-semibold leading-snug capitalize">
      {{ onSale?.title }}
    </h1>

    <!-- ACTIONS -->
    <div class="flex justify-end gap-4 mt-2 text-lg">
      <button (click)="onAddToWishList()">❤️</button>
      <button (click)="onShare()">🔗</button>
    </div>

    <hr class="my-4">

    <!-- PRICE SECTION -->
    <div>

      <div class="flex items-center gap-3">

        <!-- Original Price -->
        <span *ngIf="flatDiscount > 0" class="line-through text-gray-400 text-lg">
          {{ finalPrice | currency:'INR' }}
        </span>

        <!-- Sale Price -->
        <span class="text-2xl font-bold text-black">
          {{ salePrice | currency:'INR' }}
        </span>

      </div>

      <!-- Discount -->
      <p *ngIf="flatDiscount > 0" class="text-green-600 text-sm mt-1">
        ({{ onSale?.discount }}% OFF)
      </p>

      <p class="text-xs text-gray-500 mt-1">
        Excluding shipping fee
      </p>

    </div>

    <hr class="my-4">

    <!-- PRIMARY DETAILS (Minimal & Important Only) -->
    <div class="space-y-2 text-sm">

      <div class="flex justify-between">
        <span class="text-gray-500">Category</span>
        <span class="font-medium">{{ onSale?.product_type?.name }}</span>
      </div>

      <div class="flex justify-between">
        <span class="text-gray-500">Size</span>
        <span class="font-medium">{{ finalSize }} Inch</span>
      </div>

      <div class="flex justify-between">
        <span class="text-gray-500">Frame</span>
        <span class="font-medium">{{ onSale?.frame_name }}</span>
      </div>

    </div>

    <!-- OPTIONAL: MORE DETAILS (COLLAPSIBLE) -->
    <details class="mt-4 text-sm">
      <summary class="cursor-pointer font-medium text-blue-600">
        View Full Details
      </summary>

      <div class="mt-2 space-y-2 text-gray-600">

        <div class="flex justify-between">
          <span>Print Type</span>
          <span>{{ onSale?.print_type }}</span>
        </div>

        <div class="flex justify-between">
          <span>Print Surface</span>
          <span>{{ onSale?.print_surface }}</span>
        </div>

        <div class="flex justify-between">
          <span>Glass Type</span>
          <span>{{ onSale?.glass_type }}</span>
        </div>

        <div class="flex justify-between">
          <span>Print Size</span>
          <span>{{ onSale?.print_size }}</span>
        </div>

        <div class="flex justify-between">
          <span>Final Frame Size</span>
          <span>{{ onSale?.frame_size }}</span>
        </div>

      </div>
    </details>

    <hr class="my-4">

    <!-- BUTTONS -->
    <div class="space-y-3">

      <!-- BUY NOW -->
      <button (click)="onAddToCart()"
        class="w-full bg-black text-white py-3 rounded-lg font-medium hover:bg-gray-800 transition">
        Buy Now
      </button>

      <!-- ADD TO CART -->
      <button (click)="onAddToCart()"
        class="w-full border border-black py-3 rounded-lg font-medium hover:bg-gray-100 transition">
        Add To Cart
      </button>

      <!-- EDIT PRODUCT (CASE 1) -->
      <!-- <button *ngIf="onSale?.url?.startsWith('product-customization') && onSale?.is_edit_product == 1"
        [routerLink]="['/product-customization']" [queryParams]="getQueryParams()"
        class="w-full bg-blue-600 text-white py-3 rounded-lg font-medium hover:bg-blue-700 transition">
        Edit Product
      </button> -->

      <!-- EDIT PRODUCT (CASE 2) -->
      <!-- <button *ngIf="!onSale?.url?.startsWith('product-customization')" [routerLink]="['/wallpaper-customization']"
        [queryParams]="{ wallpaper_id: onSale?.url }"
        class="w-full bg-blue-600 text-white py-3 rounded-lg font-medium hover:bg-blue-700 transition">
        Edit Product
      </button> -->

    </div>

  </div>
</div>


<!-- ABOUT -->